import { render, staticRenderFns } from "./group.vue?vue&type=template&id=20e9d97e&scoped=true&"
import script from "./group.js?vue&type=script&lang=js&"
export * from "./group.js?vue&type=script&lang=js&"
import style0 from "./group.vue?vue&type=style&index=0&id=20e9d97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9d97e",
  null
  
)

export default component.exports